import { render, staticRenderFns } from "./document-discipline.vue?vue&type=template&id=0a24d651"
import script from "./document-discipline.vue?vue&type=script&lang=js"
export * from "./document-discipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports